import { z } from "zod"

export const ImportSchema = z.object({
  id: z.number(),
  status: z.string(),
  email_column_index: z.number().nullable(),
  custom_field_indices: z.array(z.number()).default([]),
  file_count_lines: z.number().nullable(),
  progress: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  imported_at: z.string().nullable(),
})

export type Import = z.infer<typeof ImportSchema>
